
export function getCurrentSession() {
  const accessToken = localStorage.getItem("access_token");
  const role = localStorage.getItem("role"); 
  const name = localStorage.getItem("employee_name") || localStorage.getItem("admin_name");
  const organisation = localStorage.getItem("organisation");

  if (accessToken && role) {
    return { active: true, role, name, organisation };
  }
  return { active: false };
}

export function redirectIfLoggedIn(router) {
  const session = getCurrentSession();
  console.log("🔍 Session detected:", session);

  if (!session.active) return;

  Promise.resolve().then(() => {
    if (session.role === "admin") {
      console.log("➡ Redirecting as ADMIN");
      router.push("/auth/select-organisation");
    } else if (session.role === "employee") {
      console.log("➡ Redirecting as EMPLOYEE");
      router.push("/employee/home");
    }
  });
}

